import { StorageType } from '@common/models';
import { FormType } from '@common/types';

export enum FormKey {
  AccessKey = 'accessKey',
  BucketName = 'bucketName',
  CurrentSizeBytes = 'currentSizeBytes',
  DeleteDate = 'deleteDate',
  Endpoint = 'endpoint',
  EndpointSuffix = 'endpointSuffix',
  Name = 'name',
  Region = 'region',
  RootFolder = 'rootFolder',
  SecretKey = 'secretKey',
  StorageType = 'storageType'
}

export interface BackupDTabFormStructure {
  [FormKey.AccessKey]: string;
  [FormKey.BucketName]: string;
  [FormKey.CurrentSizeBytes]?: number;
  [FormKey.DeleteDate]?: string;
  [FormKey.Endpoint]?: string;
  [FormKey.EndpointSuffix]?: string;
  [FormKey.Name]: string;
  [FormKey.Region]?: string;
  [FormKey.RootFolder]: string;
  [FormKey.SecretKey]: string;
  [FormKey.StorageType]: StorageType;
}

export type FormStructure = FormType<BackupDTabFormStructure>;
